import React from 'react';
import cx from 'classnames';
import isEqual from 'is-equal';
import buildUrl from 'build-url-ts';
import styles from './userGroupListView.module.scss';
import InfiniteScroll from 'react-infinite-scroller';
import { Image, Row, Col } from 'react-bootstrap';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import dateformat from 'dateformat';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import Text from 'src/components/text';
class UserGroupListView extends React.Component {
  constructor(props){
    super(props);

    this._handleUserGroupClick = this._handleUserGroupClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
  }

  componentDidMount() {
    this.handleUrlChange(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(_.get(this.props,"location.query"), _.get(nextProps,"location.query"))) {
      this.handleUrlChange(nextProps);
    }
  }

  componentWillUnmount() {
    this.props.showSettingsSideMenu();
  }

  handleUrlChange(props) {
    var query = props.location.query["query"] || ''
    this.props.fetchUserGroups(0, query);
  }

  _handleUserGroupClick(userGroup) {
    this.props.fetchUserGroup(userGroup.id);
    this.props.hideSettingsSideMenu();
    this.props.invalidateUserSelection();

    var queryParams = {};
    var query = this.props.location.query["query"] || ''
    if (query) {
      queryParams['query'] = query;
    }

    var path = buildUrl(null, {
      path: `/settings/user-management/group/${userGroup.id}`,
      queryParams: queryParams
    });

    this.props.navigate(path);

    if(this.props.onListItemClick) {
      this.props.onListItemClick();
    }
  }

  loadMoreItems() {
    var current = this.props.currentPage;

    if (this.props.loading) {
      return false;
    }

    var query = this.props.location.query["query"] || ''
    this.props.fetchUserGroups(current + 1, query);
  }

  render() {
    if(!this.props.userGroups) {
      return null;
    }

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={() => { this.loadMoreItems() }}
        useWindow={false}
      >
        <div className={styles.userGroupListContainer}>
          {this.props.creating && this._renderCreateNewUserGroup()}
          {this._renderUserGroups()}
        </div>
      </InfiniteScroll>
    );
  }

  renderInitials(userGroup){
    let initial = '';

    if(userGroup.name){
      initial = userGroup.name.charAt(0);
    }

    return initial.toUpperCase();
  }

  _renderCreateNewUserGroup() {
    return(
      <div className={cx(styles.userGroupRow, styles.active, {
        [styles.newGroup] : this.props.creating
      })}>
          {!this.props.showSettingsMenu && 
          <div className={styles.iconContainer}>
            <div className={styles.contactAvatar}>U</div>
          </div>}
          <Row className={styles.metadata}>
            <Col md={this.props.showSettingsMenu ? 6 : 12} className={styles.groupName}>
              <Text lines={1} text={this.localizedCommons.untitled} />
            </Col>
            <Col md={this.props.showSettingsMenu ? 6 : 12} className={styles.usersCount}>
              {`0 ${this.localizedCommons.users}`}
            </Col>
        </Row>
      </div>
    )
  }

  _renderUserGroups() {
    if ((!this.props.userGroups || this.props.userGroups.length == 0) && this.props.loading) {
      return this._renderLoading();
    }

    var rows = Array();

    this.props.userGroups.forEach((userGroup, index) => {
      rows.push(
        <div className={cx(styles.userGroupRow, {[styles.active]: userGroup.id === this.props.selectedId})}
           key={userGroup.id}
           onClick={this._handleUserGroupClick.bind(this, userGroup)}>
           {!this.props.showSettingsMenu && 
            <div className={styles.iconContainer}>
              <div className={styles.contactAvatar}> {this.renderInitials(userGroup)} </div>
            </div>}
           <Row className={styles.metadata}>
            <Col md={this.props.showSettingsMenu ? 6 : 12} className={cx(styles.groupName, {
                [styles.activeGroupName] : userGroup.id === this.props.selectedId
              })}>
              <Text lines={1} className={styles.groupNameText} text={userGroup.name}  tooltip={{placement: 'auto'}}  />
            </Col>
            {userGroup.id === this.props.selectedId && <Col md={this.props.showSettingsMenu ? 6 : 12} className={styles.createdOn}>
              {this.localizedCommons.updated_on}: {dateformat(userGroup.modifiedDate, 'dd-mmm-yyyy')}
            </Col>}
            <Col className={styles.usersCount}>
            {`${userGroup.usersCount || 0} users`}
            </Col>
          </Row>
        </div>
      )
    })

    return rows;
  }

  _renderLoading() {
    return (
      <div className={styles.loading}>
        <LoadingMessage
          className={styles.loadingInner}
          message={`${this.localizedCommonLoading.users}...`}
          visible={true} />
      </div>
    )
  }
}

export default UserGroupListView;    